import { useEffect, useState } from "react"

const options = {
  rootMargin: "0px 0px -50% 0px",
  threshold: 0,
}

export const useObserverSticky = () => {
  const [isSticky, setIsSticky] = useState(false)

  function callback(entries: IntersectionObserverEntry[]) {
    const [entry] = entries
    setIsSticky(!entry.isIntersecting)
  }

  useEffect(() => {
    const isSupported =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    let observer: IntersectionObserver
    const targetEl = document.getElementById("personal-form")

    if (isSupported) {
      observer = new IntersectionObserver(callback, options)

      if (targetEl && isSupported) {
        observer.observe(targetEl)
      }
    }

    return () => {
      if (targetEl && isSupported) {
        observer.unobserve(targetEl)
      }
    }
  }, [])

  return isSticky
}
